module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Setting Affiliate")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Setting Affiliate")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Configuration Affiliate")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("1 Rupiah (Sama dengan)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formConfig.coin_to_rupiah),
      expression: "formConfig.coin_to_rupiah"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Bilangan dalam koin"
    },
    domProps: {
      "value": (_vm.formConfig.coin_to_rupiah)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formConfig, "coin_to_rupiah", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_vm._v("Koin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Minimum cash withdrawal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-flow": ""
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formConfig.minimum_coin_withdraw),
      expression: "formConfig.minimum_coin_withdraw"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Bilangan dalam Rupiah"
    },
    domProps: {
      "value": (_vm.formConfig.minimum_coin_withdraw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formConfig, "minimum_coin_withdraw", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_vm._v("Rupiah")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "250px",
      "display": "flex",
      "align-items": "center",
      "padding-left": "20px"
    }
  }, [_vm._v("=  "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.formConfig.minimum_coin_withdraw * _vm.formConfig.coin_to_rupiah)))]), _vm._v("  Koin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Biaya admin")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-flow": ""
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formConfig.admin_coin_fee),
      expression: "formConfig.admin_coin_fee"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Bilangan dalam Rupiah"
    },
    domProps: {
      "value": (_vm.formConfig.admin_coin_fee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formConfig, "admin_coin_fee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_vm._v("Rupiah")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "250px",
      "display": "flex",
      "align-items": "center",
      "padding-left": "20px"
    }
  }, [_vm._v("=  "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.formConfig.admin_coin_fee * _vm.formConfig.coin_to_rupiah)))]), _vm._v("  Koin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelipatan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-flow": ""
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formConfig.multiple_coin_withdraw),
      expression: "formConfig.multiple_coin_withdraw"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Bilangan dalam Rupiah"
    },
    domProps: {
      "value": (_vm.formConfig.multiple_coin_withdraw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formConfig, "multiple_coin_withdraw", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_vm._v("Rupiah")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "250px",
      "display": "flex",
      "align-items": "center",
      "padding-left": "20px"
    }
  }, [_vm._v("=  "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.formConfig.multiple_coin_withdraw *
    _vm.formConfig.coin_to_rupiah)))]), _vm._v("  Koin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Captions Share Link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formConfig.affiliate_message),
      expression: "formConfig.affiliate_message"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Caption Share Product"
    },
    domProps: {
      "value": (_vm.formConfig.affiliate_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formConfig, "affiliate_message", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "white",
      "display": "flex",
      "flex-flow": "column"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white",
      "font-weight": "bold",
      "margin": "10px"
    }
  }, [_vm._v("Tekan untuk menyimpan semua perubahan\n                        data!")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-large",
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("\n                        Simpan\n                      ")])])])])]), _vm._v(" "), _c('h4', [_vm._v("Persentase Komisi :")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding-bottom": "15px",
      "padding-left": "0px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grade),
      expression: "grade"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeClass()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua Kelas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Kelas 4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Kelas 5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Kelas 6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Kelas 7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Kelas 8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Kelas 9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Kelas 10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Kelas 11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Kelas 12")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding-bottom": "15px",
      "padding-left": "0px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeState()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SUBSCRIPTION"
    }
  }, [_vm._v("SUBSCRIPTION")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TICKET"
    }
  }, [_vm._v("TICKET")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PUBLISHED"
    }
  }, [_vm._v("PUBLISHED")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UNPUBLISHED"
    }
  }, [_vm._v("UNPUBLISHED")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "cari nama produk"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchfunction()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    },
    on: {
      "click": function($event) {
        return _vm.searchfunction()
      }
    }
  }, [_vm._v("Search")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px 0px 15px 0px"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, [(_vm.pagination.currentPage !== 1) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.previous()
      }
    }
  }, [_vm._v("Previous")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.pagination.currentPage + ' / ' +
    _vm.listProduk[0].page))]), _vm._v(" "), (_vm.pagination.currentPage < _vm.listProduk[0].page) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v("Next")]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.listProduk), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item",
      staticStyle: {
        "display": "flex",
        "flex-flow": "row"
      }
    }, [_c('div', {
      staticClass: "col-md-2 col-xs-6"
    }, [_c('img', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "src": item.picture
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 col-xs-4"
    }, [_c('h4', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "15px",
        "color": "green"
      }
    }, [_vm._v("Rp " + _vm._s(_vm._f("currency")(item.net_price)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "15px 15px 15px 0px"
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.short_description),
        expression: "item.short_description"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": item.edit === false,
        "placeholder": "Meta Tag Sosmed"
      },
      domProps: {
        "value": (item.short_description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "short_description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "input-group",
      staticStyle: {
        "width": "100px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.persentate_commission),
        expression: "item.persentate_commission"
      }],
      staticClass: "form-control",
      staticStyle: {
        "border": "2px solid green"
      },
      attrs: {
        "disabled": item.edit === false,
        "type": "number",
        "placeholder": "Dalam persen"
      },
      domProps: {
        "value": (item.persentate_commission)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "persentate_commission", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon",
      attrs: {
        "id": "basic-addon2"
      }
    }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 col-xs-2"
    }, [(item.edit === false) ? _c('button', {
      staticClass: "btn btn-warning btn-large",
      on: {
        "click": function($event) {
          item.edit = true
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (item.edit === true) ? _c('button', {
      staticClass: "btn btn-success btn-large",
      attrs: {
        "disabled": item.status === 'UNPUBLISHED'
      },
      on: {
        "click": function($event) {
          return _vm.updateProduct(item)
        }
      }
    }, [_vm._v("\n                      Simpan\n                    ")]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "id": "msg"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Setting")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4ae52ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affiliate/setting/AffiliateSetting.vue
// module id = 1390
// module chunks = 0